const ON_CHANGE_DEBOUNCE_TIMER = 300;
const FETCH_DEBOUNCE_TIMER = 750;

const CUSA_CONTENT_CLICK_DELIMITER = '||||';
const CUSA_CONTENT_CLICK_MAX = 5;

const PUB_SUB_EVENTS = {
	cartUpdate: 'cart-update',
	cartWriteComplete: 'cart-write-complete',
	cusaCartActivity: 'cusa-cart-activity',
	quantityUpdate: 'quantity-update',
	variantChange: 'variant-change',
	cartError: 'cart-error',
	updateRoyalty: 'update-royalty',
	guardiansAction: 'guardians-action',
	guardianDataSet: 'guardian-data:set',
	guardianLoadingDelayed: 'guardian-data-loading:delayed',
	guardianLoadingTimeout: 'guardian-data-loading:timedout',
	guardianLoadingError: 'guardian-data-loading:error',
	cusaToastDismiss: 'cusa-toast:dismiss'
};
